import { render, staticRenderFns } from "./CmgAddGiftCardModal.vue?vue&type=template&id=df64a03e&scoped=true&lang=pug"
import script from "./cmg-add-gift-card-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-add-gift-card-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAddGiftCardModal.vue?vue&type=style&index=0&id=df64a03e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df64a03e",
  null
  
)

export default component.exports